import { render, staticRenderFns } from "./WallGiftRegistryBlock.vue?vue&type=template&id=f28c9bc2"
import script from "./WallGiftRegistryBlock.vue?vue&type=script&lang=js"
export * from "./WallGiftRegistryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports